export function dateIsEqualOrOlderThanNDays({ date, now = new Date(), days }) {
  const diff = now.getTime() - date.getTime()
  const diffInDays = diff / (1000 * 3600 * 24)
  return diffInDays >= days
}

export function nDaysFrom({ date, days }) {
  const newDate = new Date(date.getTime())
  newDate.setTime(newDate.getTime() + days * 24 * 60 * 60 * 1000)
  return newDate
}

export function dateIsEqualOrOlderThanNHours({ date, now = new Date(), hours }) {
  const diff = now.getTime() - date.getTime()
  const diffInHours = diff / (1000 * 3600)
  return diffInHours >= hours
}

export function nHoursFrom({ date, hours }) {
  const newDate = new Date(date.getTime())
  newDate.setTime(newDate.getTime() + hours * 60 * 60 * 1000)
  return newDate
}

export function addDaysToDate(date: Date, days: number): Date {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + days)
  return newDate
}

export const getDaySuffix = (day: number) => {
  if (day === 1 || day === 21 || day === 31) {
    return 'st'
  } else if (day === 2 || day === 22) {
    return 'nd'
  } else if (day === 3 || day === 23) {
    return 'rd'
  } else {
    return 'th'
  }
}

export const formatDatePartsWithDaySuffix = (parts: Intl.DateTimeFormatPart[]) =>
  parts
    .map((part) =>
      part.type === 'day'
        ? `${part.value}${getDaySuffix(Number(part.value))}`
        : part.type === 'month'
        ? part.value + '.'
        : part.value
    )
    .join('')

// Converts a date (if needed) for the local day to match the UTC day
export const adjustLocalDateForUTCBoundary = (date: Date) => {
  let newDate = new Date(date.getTime())

  if (newDate.getUTCDate() !== newDate.getDate()) {
    // We add one day (UTC-X) if the local date is not yet in the current UTC day
    // or we subtract one day (UTC+X) if the local date is already in the next day in UTC
    const dayOffset = newDate.getTimezoneOffset() > 0 ? 1 : -1
    newDate = addDaysToDate(newDate, dayOffset)
  }
  return newDate
}

export function getNextMonthFirstDayFormatted(): string {
  const currentDate = new Date()
  const nextMonth = currentDate.getMonth() + 1
  const nextYear = currentDate.getFullYear() + (nextMonth > 11 ? 1 : 0)
  const firstDayNextMonth = new Date(nextYear, nextMonth % 12, 1)

  return firstDayNextMonth.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

// TODO VVG: consider reactor and merge several utils into one for dates (eg. calculateDaysDifference, dateIsEqualOrOlderThanNDays, etc.)
